import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import { SkeletonBlock } from '../common/Skeleton.web';

const BUBBLE_PATTERN: readonly {
  align: 'flex-start' | 'flex-end';
  width: number;
  height: number;
}[] = [
  { align: 'flex-start', width: 220, height: 58 },
  { align: 'flex-end', width: 180, height: 36 },
  { align: 'flex-start', width: 160, height: 36 },
  { align: 'flex-end', width: 240, height: 72 },
  { align: 'flex-start', width: 140, height: 36 },
  { align: 'flex-end', width: 200, height: 48 },
];

export const MessagesThreadSkeleton = memo(function MessagesThreadSkeleton() {
  const { theme } = useTheme();

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: theme.background,
        padding: 16,
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      {BUBBLE_PATTERN.map((bubble, index) => (
        <div
          key={`message-bubble-skeleton-${index}`}
          style={{ display: 'flex', justifyContent: bubble.align }}
        >
          <SkeletonBlock width={bubble.width} height={bubble.height} radius={20} />
        </div>
      ))}
    </div>
  );
});
